import { lazy } from 'react';

const InvoicesList = lazy(() =>  import('../pages/Invoices/List'));
const InvoicesDetail = lazy(() =>  import('../pages/Invoices/Detail'));
const InvoicesPrint = lazy(() =>  import('../pages/Invoices/Print'));

export default [{
    path: "/invoices",
    element: InvoicesList,
    analytics: { name: ["Fatture"]}
}, {
    path: "/invoices/:invoiceId",
    element: InvoicesDetail,
    analytics: { name: ["Fatture", "Dettaglio"]},
}, {
    path: "/invoices/:invoiceId/print",
    element: InvoicesPrint,
    analytics: { name: ["Fatture", "Stampa"]},
}]
